(function () {
  'use strict';

  function removeSpecialUrlChars(name) {
    return name.replace(/[,!#$%^&*(){}[\]<>;'?=":]/g, '').replace(/\s+/g, '-');
  }
  // Ensure global alias for compatibility with bundled callers
  if (
    typeof window !== 'undefined' &&
    typeof window.removeSpecialUrlChars !== 'function'
  ) {
    window.removeSpecialUrlChars = removeSpecialUrlChars;
  }

  function getSignedUploadUrl(contentType, fileName) {
    return fetch(
      '/file-upload-get-signed-url-cloudflare?' +
        new URLSearchParams({
          file_type: contentType,
          file_name: fileName,
        }),
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }
    ).then((r) => r.json());
  }

  function getSignedURLAndUpload(file, type, name, onProgress) {
    const signedUploadUrlPromise = getSignedUploadUrl(type, name);
    function uploadToSignedUrlPromise(signedUrl) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', signedUrl.url, true);
        xhr.onload = () => {
          const status = xhr.status;
          if (status === 200) {
            resolve(signedUrl);
          } else {
            reject(new Error('Something went wrong!'));
          }
        };
        xhr.onerror = () => reject(new Error('Something went wrong'));
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable && onProgress) {
            onProgress(Math.round((event.loaded / event.total) * 100));
          }
        };
        xhr.setRequestHeader('Content-Type', type);
        xhr.send(file);
      });
    }
    return signedUploadUrlPromise.then(uploadToSignedUrlPromise);
  }

  // Ensure global aliases for callers that expect globals
  if (typeof window !== 'undefined') {
    if (typeof window.getSignedUploadUrl !== 'function') {
      window.getSignedUploadUrl = getSignedUploadUrl;
    }
    if (typeof window.getSignedURLAndUpload !== 'function') {
      window.getSignedURLAndUpload = getSignedURLAndUpload;
    }
  }

  // Expose class globally for tests and late injection
  window.MediaUploadHandler = class MediaUploadHandler {
    constructor() {
      this.textGeneratorApiKey = '2VukOB0SGY0zdWFFXlw5HBJ6xLlxuyP2';
      this.maxImageSize = 1024 * 1024;
      this.processingCount = 0;
      this.imageScope = 0;
      this.maxVideoSize = 10 * 1024 * 1024; // 10MB
      this.pendingMedia = [];
      this.chatImageHistory = [];
      this._ensureCssInjected();
      this.initializeEventListeners();
      this.ensureAttachFab();
      window.addEventListener('netwrck:private-room-start', () => this.resetChatImages());
    }

    initializeEventListeners() {
      // Attach button click handler (hosted button)
      $(document).on('click', '#attach-media', (e) => {
        e.preventDefault();
        const input = document.getElementById('media-file-input');
        if (input) input.click();
      });

      // File input change handler
      $(document).on('change', '#media-file-input', (e) => {
        this.handleFileSelection(e);
      });

      // Paste event for images
      $(document).on('paste', (e) => {
        const clipboardData =
          e.originalEvent.clipboardData || window.clipboardData;
        if (!clipboardData || !clipboardData.items) return;
        const items = clipboardData.items;
        const files = [];
        for (let i = 0; i < items.length; i++) {
          if (items[i].type && items[i].type.indexOf('image') !== -1) {
            const file = items[i].getAsFile();
            if (file) {
              files.push(file);
            }
          }
        }
        if (files.length) this.handleFileSelection({ target: { files } });
      });

      // Ensure a hidden file input exists for programmatic use
      if (!document.getElementById('media-file-input')) {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*,video/*';
        input.multiple = true;
        input.id = 'media-file-input';
        input.style.display = 'none';
        document.body.appendChild(input);
      }
    }

    _ensureCssInjected() {
      if (document.getElementById('media-upload-css-link')) return;
      const link = document.createElement('link');
      link.id = 'media-upload-css-link';
      link.rel = 'stylesheet';
      link.href = (window.STATIC_URL || '/static') + '/css/media-upload.css';
      document.head.appendChild(link);
    }

    ensureAttachFab() {
      if (document.getElementById('attach-media-fab')) return;
      const fab = document.createElement('button');
      fab.id = 'attach-media-fab';
      fab.type = 'button';
      fab.setAttribute('aria-label', 'Attach media');
      fab.innerHTML = '<span style="font-size:20px;line-height:0">📎</span>';
      document.body.appendChild(fab);
      fab.addEventListener('click', (e) => {
        e.preventDefault();
        const input = document.getElementById('media-file-input');
        if (input) input.click();
      });
    }

    async handleFileSelection(event) {
      const files = Array.from(event.target.files || []);
      if (files.length === 0) return;
      try {
        const scope = this.imageScope;
        for (const file of files) {
          if (scope !== this.imageScope) break;
          await this.processFile(file);
        }
      } catch (error) {
        console.error('Error processing files:', error);
        alert(
          'Error processing files: ' +
            (error && error.message ? error.message : error)
        );
      } finally {
        // Clear the input for subsequent selections
        if (event && event.target) event.target.value = '';
      }
    }

    async processFile(file) {
      const scope = this.imageScope;
      this.processingCount++;
      this.showLoadingIndicator();
      try {
        let processedFile = file;
        if (file.type.startsWith('image/')) {
          processedFile = await this.compressImageToWebP(file);
          if (scope !== this.imageScope) return;
          let uploadResult, caption;
          if (this.isPrivateChat()) {
            uploadResult = { url: await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.onerror = () => reject(new Error('Failed to read image'));
              reader.readAsDataURL(processedFile);
            }) };
            caption = file.name;
          } else {
            uploadResult = await this.uploadFile(processedFile);
            caption = file.name;
          }
          if (scope !== this.imageScope) return;
          this.addMediaToChat(
            uploadResult,
            caption || file.name,
            processedFile.type
          );
        } else if (file.type.startsWith('video/')) {
          if (this.isPrivateChat()) throw new Error('Private chat currently supports image attachments only');
          processedFile = await this.compressVideoToWebM(file);
          const [uploadResult, transcript] = await Promise.all([
            this.uploadFile(processedFile),
            this.transcribeMedia(processedFile),
          ]);
          if (scope !== this.imageScope) return;
          this.addMediaToChat(uploadResult, transcript || file.name, file.type);
        }
      } catch (error) {
        console.error('Error processing file:', error);
        alert(`Error processing ${file.name}: ${error.message || error}`);
      } finally {
        if (scope === this.imageScope) {
          this.processingCount--;
          this.hideLoadingIndicator();
        }
      }
    }

    async compressImageToWebP(file) {
      if (file.size > 32 * 1024 * 1024) throw new Error('Images must be 32 MB or smaller');
      return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        const objectURL = URL.createObjectURL(file);
        img.onload = () => {
          const maxDimension = 800;
          const sourceWidth = img.naturalWidth || img.width;
          const sourceHeight = img.naturalHeight || img.height;
          if (sourceWidth * sourceHeight > 24 * 1024 * 1024) {
            URL.revokeObjectURL(objectURL);
            reject(new Error('Images must be 24 megapixels or smaller'));
            return;
          }
          const scale = Math.min(
            1,
            maxDimension / sourceWidth,
            maxDimension / sourceHeight
          );
          const width = Math.max(1, Math.round(sourceWidth * scale));
          const height = Math.max(1, Math.round(sourceHeight * scale));
          canvas.width = width;
          canvas.height = height;
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, width, height);
          URL.revokeObjectURL(objectURL);
          canvas.toBlob(
            (blob) => {
              if (blob && blob.type === 'image/webp' && blob.size <= this.maxImageSize) {
                const compressedFile = new File(
                  [blob],
                  file.name.replace(/\.[^/.]+$/, '') + '.webp',
                  {
                    type: 'image/webp',
                  }
                );
                resolve(compressedFile);
              } else {
                reject(new Error('Unable to encode image as WebP under 1 MB'));
              }
            },
            'image/webp',
            0.85
          );
        };
        img.onerror = () => {
          URL.revokeObjectURL(objectURL);
          reject(new Error('Failed to load image'));
        };
        img.src = objectURL;
      });
    }

    async compressVideoToWebM(file) {
      // For now, return the original file (placeholder)
      console.log('Video compression not implemented yet, using original file');
      return file;
    }

    async getCaptionFromAPI(file) {
      try {
        const formData = new FormData();
        formData.append('image_file', file);
        formData.append('fast_mode', true);
        const response = await fetch(
          'https://api.text-generator.io/api/v1/image-caption',
          {
            method: 'POST',
            headers: {
              secret: this.textGeneratorApiKey,
            },
            body: formData,
          }
        );
        if (!response.ok) {
          throw new Error(`Caption API failed: ${response.status}`);
        }
        const data = await response.json();
        return data.caption || file.name;
      } catch (error) {
        console.error('Error getting caption:', error);
        return file.name;
      }
    }

    async uploadFile(file) {
      try {
        const fileName = removeSpecialUrlChars(file.name);
        const signedUrl = await getSignedURLAndUpload(
          file,
          file.type,
          fileName
        );
        const bucket = signedUrl.bucket_name || 'netwrckstatic.netwrck.com';
        return {
          success: true,
          filename: fileName,
          url: `https://${bucket}/${signedUrl.object_path}`,
          bucket: bucket,
          object_path: signedUrl.object_path,
          size: file.size,
          type: file.type,
        };
      } catch (error) {
        console.error('Upload error:', error);
        throw new Error(`Upload failed: ${error.message || error}`);
      }
    }

    async transcribeMedia(file) {
      try {
        if (
          window.LocalTranscription &&
          typeof window.LocalTranscription.transcribe === 'function'
        ) {
          const localResult = await window.LocalTranscription.transcribe(file);
          const localText = String(
            localResult?.text || localResult || ''
          ).trim();
          if (localText) return localText;
        }
        const formData = new FormData();
        formData.append('audio_file', file, file.name || 'upload.webm');
        const response = await fetch('/api/transcribe', {
          method: 'POST',
          body: formData,
        });
        if (!response.ok) return '';
        const data = await response.json();
        return String(data.text || data.transcript || '').trim();
      } catch (error) {
        return '';
      }
    }

    addMediaToChat(uploadResult, caption, fileType) {
      const originalUpload = uploadResult;
      const originalCaption = caption;
      const escape = value => String(value || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
      caption = escape(caption);
      uploadResult = { ...uploadResult, url: escape(uploadResult.url) };
      const $textarea = $('#main-chatbox');
      const $question = $('.question-text');
      const hasTextArea = $textarea.length > 0;
      const currentText = hasTextArea
        ? $textarea.val() || ''
        : $question.val && $question.val()
          ? $question.val()
          : '';

      let mediaHTML = '';
      if (fileType.startsWith('image/')) {
        mediaHTML = `
                    <div class="chat-media-attachment" style="
                        display: inline-block;
                        margin: 10px 0;
                        padding: 8px;
                        background: #f5f5f5;
                        border-radius: 12px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    ">
                        <img src="${uploadResult.url}" alt="${caption}" style="
                            max-width: 300px;
                            max-height: 200px;
                            border-radius: 8px;
                            display: block;
                        ">
                        <div style="
                            margin-top: 8px;
                            padding: 4px 8px;
                            background: white;
                            border-radius: 4px;
                            font-size: 12px;
                            color: #666;
                            font-style: italic;
                        ">${caption}</div>
                    </div>
                `;
      } else if (fileType.startsWith('video/')) {
        mediaHTML = `
                    <div class="chat-media-attachment" style="
                        display: inline-block;
                        margin: 10px 0;
                        padding: 8px;
                        background: #f5f5f5;
                        border-radius: 12px;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    ">
                        <video src="${uploadResult.url}" controls style="
                            max-width: 300px;
                            max-height: 200px;
                            border-radius: 8px;
                            display: block;
                        "></video>
                        <div style="
                            margin-top: 8px;
                            padding: 4px 8px;
                            background: white;
                            border-radius: 4px;
                            font-size: 12px;
                            color: #666;
                            font-style: italic;
                        ">${caption}</div>
                    </div>
                `;
      }

      const userMessage = `
                <div class="chat-log__item chat-log__item--own">
                    ${mediaHTML}
                    <div class="chat-log__message" style="margin-top: 5px;">${caption}</div>
                </div>
            `;
      if (typeof appendToChatLog === 'function') {
        appendToChatLog(userMessage);
      } else {
        // Fallback append
        const chatLog = document.querySelector('.chat-log');
        if (chatLog) chatLog.insertAdjacentHTML('beforeend', userMessage);
      }

      // Do not inject markdown into the input field; autosend UI is sufficient

      this.queuePendingImage(originalUpload, originalCaption, fileType);
      if (window.fixtures?.room_name && window.questionsgame?.game) {
        window.questionsgame.game.allMessages.push(originalCaption || 'Attached image');
        window.questionsgame.game.allMessagesCharacters.push(window.userData?.username || window.userData?.name || 'Noo');
      }

      this.storeMediaInfo(uploadResult, caption, fileType, mediaHTML);
    }

    queuePendingImage(uploadResult, caption, fileType) {
      if (!fileType || !fileType.startsWith('image/')) return;
      if (!Array.isArray(this.pendingChatImages)) this.pendingChatImages = [];
      if (!Array.isArray(this.chatImageHistory)) this.chatImageHistory = [];
      const url = uploadResult && (uploadResult.url || uploadResult.public_url);
      if (!url) return;
      const image = { url: url, caption: caption || '' };
      this.pendingChatImages.push(image);
      if (this.pendingChatImages.length > 4) this.pendingChatImages.shift();
      this.chatImageHistory.push(image);
      if (this.chatImageHistory.length > 20) {
        this.chatImageHistory = this.chatImageHistory.slice(-20);
      }
    }

    getChatImageContext() {
      if (!Array.isArray(this.chatImageHistory)) return [];
      return this.chatImageHistory.slice(this.isPrivateChat() ? -4 : -20);
    }

    consumePendingChatImages() {
      const pending = this.pendingChatImages || [];
      this.pendingChatImages = [];
      return pending;
    }

    storeMediaInfo(uploadResult, caption, fileType, mediaHTML) {
      if (this.isPrivateChat()) return;
      try {
        const mediaStore = JSON.parse(
          sessionStorage.getItem('chatMedia') || '[]'
        );
        mediaStore.push({
          uploadResult,
          caption,
          fileType,
          mediaHTML,
          timestamp: Date.now(),
        });
        sessionStorage.setItem('chatMedia', JSON.stringify(mediaStore));
      } catch (e) {
        /* ignore quota errors */
      }
    }

    isPrivateChat() {
      return !!window.fixtures?.room_is_private || new URLSearchParams(window.location.search).get('anon_chat') === '1';
    }

    resetChatImages() {
      this.imageScope = (this.imageScope || 0) + 1;
      this.processingCount = 0;
      this.pendingChatImages = [];
      this.chatImageHistory = [];
      this.hideLoadingIndicator();
    }

    showLoadingIndicator() {
      document.getElementById('attach-media-fab')?.setAttribute('aria-busy', 'true');
    }

    hideLoadingIndicator() {
      if (!this.processingCount) document.getElementById('attach-media-fab')?.removeAttribute('aria-busy');
    }
  };

  // Auto-initialize once per page
  function autoInit() {
    try {
      if (!window.mediaUploadHandler) {
        window.mediaUploadHandler = new window.MediaUploadHandler();
      }
    } catch (e) {
      // ignore
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }
})();
